import { apiPromiseAction } from 'promise-action';

import * as api from 'common/api/contractApi';

// eslint-disable-next-line import/prefer-default-export
export const sign = apiPromiseAction
  .create(api.sign)
  .normalizeResponse(({ data }) => data);
